<div *transloco="let t" class="onboarding-page-container">
  <div class="title">
    {{ t('onboarding.secondPage.text', {amountSpent: amountSpent()}) }}
    <lib-pill-logo [companyName]="companyName()" [companyLogo]="companyLogo()" [size]="Size.BIG"></lib-pill-logo>
  </div>
  <img class="star star-half" ngSrc="assets/images/onboarding/star-half.png" alt="multicolored start" priority
       height="179" width="65">
  <img class="star star-rising" ngSrc="assets/images/onboarding/star-rising.png" alt="rising start" priority
       height="303" width="367">
  <img class="star coin" ngSrc="assets/images/onboarding/coin.png" alt="coin" priority height="420" width="420">
</div>
